import Vue, { VNode } from 'vue';
import SerfQueueView from '@/views/SerfQueueView.vue';
import api from '@/rest-api';
import {
  SerfJob, SerfJobAndManifest, SerfJobManifest,
} from '@/model';
import JobQueueSubscriber from '@/controllers/JobQueueSubscriber';
import mixins from '@/plugins/typed-mixins';

export default mixins(JobQueueSubscriber).extend({
  name: 'SerfQueueController',
  components: {
    SerfQueueView,
  },

  props: {
    duplicateJobId: { type: Number as () => number | undefined, required: false },
  },

  data() {
    return {
      loading: false,
      jobs: [] as SerfJob[],
      createJob: undefined as Partial<SerfJobAndManifest> | undefined,
    };
  },

  mounted() {
    if (this.duplicateJobId) {
      this.duplicateJob(this.duplicateJobId);
    }
    this.load();
    this.startSSEMonitoring();
  },

  methods: {
    async load() {
      this.loading = true;
      this.jobs = await api.jobs();
      this.loading = false;
    },

    startSSEMonitoring() {
      // Subscribe to all job state changes and update the job list in real-time
      this.subscribeUntil((job: SerfJob) => {
        // Find the job in our list and update it
        const index = this.jobs.findIndex((j) => j.id === job.id);
        if (index >= 0) {
          // Update existing job
          Vue.set(this.jobs, index, job);
        } else {
          // Add new job to the beginning of the list
          this.jobs.unshift(job);
        }

        // Never unsubscribe - keep monitoring all jobs
        return false;
      }).catch((error) => {
        console.error('SSE monitoring error:', error);
        // Retry after a delay
        setTimeout(() => this.startSSEMonitoring(), 5000);
      });
    },
    async save(manifest: SerfJobManifest) {
      await api.createJob(manifest);
      this.load();
    },
    async duplicateJob(jobId: number) {
      const [job, manifest] = await Promise.all([api.job(jobId), api.manifest(jobId)]);
      this.createJob = { job, manifest };
    },
  },

  render(create): VNode {
    return create(
      SerfQueueView, {
        props: {
          loading: this.loading,
          jobs: this.jobs,
          createJob: this.createJob,
        },
        on: {
          load: this.load,
          save: this.save,
          duplicateJob: this.duplicateJob,
        },
      },
    );
  },

});
